/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/countrySelect.scss';

import {
    ChangeFunction,
    ChangeKeyFunction,
    Checkbox,
    CloseButton,
    Loader,
    voidFunction,
    WithBackground
} from '@dvrd/dvr-controls';
import React, {CSSProperties, MouseEventHandler} from 'react';
import {BolmateButton} from "../../../index";
import FixedSizeChecklist from "../../../../misc/fixedSizeChecklist";

interface Props {
    onSelectCountry: ChangeKeyFunction;
    onSelectAll: ChangeFunction;
    onSubmit: MouseEventHandler;
    onClose: MouseEventHandler;
    allSelected: boolean;
    loading: boolean;
    active: boolean;
    countries: string[];
    selectedCountries: Set<string>;
}

export default function CountrySelect(props: Props) {
    const {
        selectedCountries, active, onClose, onSelectCountry, onSelectAll, allSelected, loading, onSubmit, countries
    } = props;

    function renderBody() {
        const selectable = countries.filter((country: string) => !selectedCountries.has(country));
        return (
            <div className='body-container'>
                <Loader active={loading}/>
                <Checkbox checked={allSelected} onCheck={onSelectAll} label='Alle landen' className='grid-col-3'/>
                <div className='col'>
                    <label className='col-title'>Beschikbare landen</label>
                    <FixedSizeChecklist items={selectable} renderRow={renderCountry(false)} disabled={loading}/>
                </div>
                <div className='divider'/>
                <div className='col'>
                    <label className='col-title'>Geselecteerde landen{allSelected ? ' (alle)' : ''}</label>
                    <FixedSizeChecklist items={Array.from(selectedCountries)} renderRow={renderCountry(true)}
                                        disabled={loading || allSelected}/>
                </div>
            </div>
        )
    }

    function renderCountry(selected: boolean) {
        return function (country: string, index: number, style: CSSProperties) {
            return (
                <div style={style} onClick={onSelectCountry(country)} className='list-row'>
                    <Checkbox key={index} checked={selected} onCheck={voidFunction} label={country}/>
                </div>
            )
        }
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='country-select default-popup'>
                <div className='header-container'>
                    <label className='header-title'>Landen selecteren</label>
                    <CloseButton onClick={onClose}/>
                </div>
                {renderBody()}
                <div className='footer-container'>
                    <BolmateButton onClick={onSubmit} label='Klaar' disabled={loading}/>
                </div>
            </div>
        </WithBackground>
    )
}